// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/messages/message.proto (package protos.entities.app.messages, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { MessageType } from "./message_type_pb";
import { file_entities_app_messages_message_type } from "./message_type_pb";
import type { MessageData } from "./message_data_pb";
import { file_entities_app_messages_message_data } from "./message_data_pb";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/messages/message.proto.
 */
export const file_entities_app_messages_message: GenFile = /*@__PURE__*/
  fileDesc("CiNlbnRpdGllcy9hcHAvbWVzc2FnZXMvbWVzc2FnZS5wcm90bxIccHJvdG9zLmVudGl0aWVzLmFwcC5tZXNzYWdlcyLYAwoHTWVzc2FnZRISCgptZXNzYWdlX2lkGAEgASgJEg8KB2NoYXRfaWQYAiABKAkSGQoRY2xpZW50X21lc3NhZ2VfaWQYAyABKAkSPwoMbWVzc2FnZV90eXBlGAQgASgOMikucHJvdG9zLmVudGl0aWVzLmFwcC5tZXNzYWdlcy5NZXNzYWdlVHlwZRI3CgRkYXRhGAUgASgLMikucHJvdG9zLmVudGl0aWVzLmFwcC5tZXNzYWdlcy5NZXNzYWdlRGF0YRJDCgpjcmVhdGVkX2J5GAYgASgLMi8ucHJvdG9zLmVudGl0aWVzLmFwcC5tZXNzYWdlcy5NZXNzYWdlLkNyZWF0ZWRCeRIuCgpjcmVhdGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBpuCglDcmVhdGVkQnkSEgoKYWNjb3VudF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEg8KB3BmcF91cmwYAyABKAkSLgoKdXBkYXRlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBiBnByb3RvMw", [file_google_protobuf_timestamp, file_entities_app_messages_message_type, file_entities_app_messages_message_data]);

/**
 * @generated from message protos.entities.app.messages.Message
 */
export type Message = Message$1<"protos.entities.app.messages.Message"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string chat_id = 2;
   */
  chatId: string;

  /**
   * @generated from field: string client_message_id = 3;
   */
  clientMessageId: string;

  /**
   * @generated from field: protos.entities.app.messages.MessageType message_type = 4;
   */
  messageType: MessageType;

  /**
   * @generated from field: protos.entities.app.messages.MessageData data = 5;
   */
  data?: MessageData | undefined;

  /**
   * @generated from field: protos.entities.app.messages.Message.CreatedBy created_by = 6;
   */
  createdBy?: Message_CreatedBy | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.entities.app.messages.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message, 0);

/**
 * @generated from message protos.entities.app.messages.Message.CreatedBy
 */
export type Message_CreatedBy = Message$1<"protos.entities.app.messages.Message.CreatedBy"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string pfp_url = 3;
   */
  pfpUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.entities.app.messages.Message.CreatedBy.
 * Use `create(Message_CreatedBySchema)` to create a new message.
 */
export const Message_CreatedBySchema: GenMessage<Message_CreatedBy> = /*@__PURE__*/
  messageDesc(file_entities_app_messages_message, 0, 0);

